import { doc, getDoc, onSnapshot, serverTimestamp, setDoc } from 'firebase/firestore';
import { db } from './config';
import { ALL_PERMISSION_KEYS } from '../constants/permissions';

const ALLOWED = new Set(ALL_PERMISSION_KEYS);

export const listenToUserPermissions = (userId, callback) => {
  if (!userId) {
    callback([]);
    return () => {};
  }
  return onSnapshot(
    doc(db, 'userPermissions', userId),
    (snap) => callback(snap.exists() ? snap.data().permissions || [] : []),
    () => callback([])
  );
};

export const getUserPermissions = async (userId) => {
  if (!userId) return [];
  try {
    const snap = await getDoc(doc(db, 'userPermissions', userId));
    return snap.exists() ? snap.data().permissions || [] : [];
  } catch {
    return [];
  }
};

export const setUserPermissions = async (userId, permissions, updatedBy) => {
  if (!userId) throw new Error('userId is required');
  const sanitized = Array.from(
    new Set((permissions || []).filter((v) => typeof v === 'string' && ALLOWED.has(v)))
  );
  await setDoc(doc(db, 'userPermissions', userId), {
    permissions: sanitized,
    updatedAt: serverTimestamp(),
    updatedBy: updatedBy || null,
  });
  return true;
};
